
























































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeFidelizacaoStore from '@/components/Backoffice/Store/BackofficeFidelizacaoStore'
import BackofficeAgendamentoStore from '@/components/Backoffice/Store/BackofficeAgendamentoStore'
import BackofficeAutorizacaoStore from '@/components/Backoffice/Store/BackofficeAutorizacaoStore'
import BackofficePreAnestesicoStore from '@/components/Backoffice/Store/BackofficePreAnestesicoStore'
import BackofficeOrcamentoStore from '@/components/Backoffice/Store/BackofficeOrcamentoStore'
import BackofficeAgenciaTransfusionalStore from '@/components/Backoffice/Store/BackofficeAgenciaTransfusionalStore'
import BackofficeMapaCirurgicoStore from '@/components/Backoffice/Store/BackofficeMapaCirurgicoStore'
import BackofficeSuprimentosStore from '@/components/Backoffice/Store/BackofficeSuprimentosStore'
import moment from 'moment'
import TecnicaDaCirurgiaEnum from '@/types/enum/TecnicaDaCirurgiaEnum'
import { StatusCirurgiaEnum, TemplateMapaCirurgicoKey } from '@/types/_'
import EventBus from '@/plugins/EventBus'
import ComplexidadeEnum from '@/types/enum/ComplexidadeEnum'
import TipoTabelaProcedimentoEnum from '@/types/enum/TipoTabelaProcedimentoEnum'
import { useMedicos, useCbos } from '@/composables'
import BackofficeFarmaciaStore from '../Store/BackofficeFarmaciaStore'

type FiltroMedicoEspecialidade = BackofficeAgendamentoStore | BackofficeMapaCirurgicoStore
type BateMapaArea = {
  id: TemplateMapaCirurgicoKey,
  value: string,
  text: string,
}
type FiltroComplexidade = BackofficeAgendamentoStore | BackofficeMapaCirurgicoStore | BackofficeMapaCirurgicoStore
type FiltroProcedimentoPrincipal = BackofficeAgendamentoStore | BackofficeAutorizacaoStore | BackofficePreAnestesicoStore
  | BackofficeOrcamentoStore | BackofficeAgenciaTransfusionalStore | BackofficeMapaCirurgicoStore
  | BackofficeSuprimentosStore | BackofficeFarmaciaStore
type FiltroTriStateOption = {
  value: boolean | null,
  description: string,
}

@Component
export default class ComponentBackofficeRightNavBar extends Vue {
  @Prop({ required: true, default: 'agendamento' }) area: string

  $refs!: {
    cirurgiaDe: any,
    cirurgiaAte: any,
  }

  statusPrecificacaoOperadoraOptions: any[] = [
    // { status: null, nome: 'Sem precificação' },
    { status: 'PrecificacaoPendente', nome: 'Precificação pendente' },
    { status: 'Precificado', nome: 'Precificado' },
  ]

  fltLoading: boolean = false
  modDe: boolean = false
  modAte: boolean = false
  bateMapaBaseOptions: BateMapaArea[] = [
    { id: 'agendamento', value: 'ConfirmacaoAgendamento', text: 'Agendamento' },
    { id: 'autorizacao', value: 'ConfirmacaoAutorizacao', text: 'Autorização' },
    { id: 'anestesia', value: 'ConfirmacaoAnestesia', text: 'Anestesia' },
    { id: 'centralDeMateriaisEspeciais', value: 'ConfirmacaoCentralDeMateriaisEspeciais', text: 'CME - Central de materiais especiais' },
    { id: 'centroCirurgico', value: 'ConfirmacaoCentroCirurgico', text: 'Centro cirúrgico' },
    { id: 'engenhariaClinica', value: 'ConfirmacaoEngenhariaClinica', text: 'Engenharia clínica' },
    { id: 'farmacia', value: 'ConfirmacaoFarmacia', text: 'Farmácia' },
    { id: 'gerenciamentoLeito', value: 'ConfirmacaoGerenciamentoLeito', text: 'Gerenciamento de leitos' },
    { id: 'bancoDeSangue', value: 'ConfirmacaoBancoDeSangue', text: 'Banco de Sangue' },
    { id: 'tesouraria', value: 'ConfirmacaoTesouraria', text: 'Tesouraria' },
    { id: 'hotelaria', value: 'ConfirmacaoHotelaria', text: 'Hotelaria' },
    { id: 'preInternacao', value: 'ConfirmacaoPreInternacao', text: 'Pré internação' },
    { id: 'opme', value: 'ConfirmacaoOpme', text: 'Opme' },
    { id: 'suprimentos', value: 'ConfirmacaoSuprimentos', text: 'Suprimentos' },
  ]

  get especialidades() {
    return [...useCbos.cbos].sort((a, b) => a.descricao.localeCompare(b.descricao))
  }

  get allEspecialidadesSelected() {
    return this.especialidades.length > 0 && this.medicoSolicitanteEspecialidade.length === this.especialidades.length
  }

  toggleAllEspecialidades() {
    if (this.allEspecialidadesSelected) {
      this.medicoSolicitanteEspecialidade = []
    } else {
      this.medicoSolicitanteEspecialidade = this.especialidades.map(especialidade => especialidade.descricao)
    }
  }

  removeEspecialidadeItem(item: string) {
    const index = this.medicoSolicitanteEspecialidade.indexOf(item)
    if (index > -1) {
      this.medicoSolicitanteEspecialidade = this.medicoSolicitanteEspecialidade.filter(especialidade => especialidade !== item)
    }
  }

  async loadEspecialidades() {
    await useCbos.loadCbos()
  }

  get doctors() {
    return useMedicos.medicosByCurrentUser
  }

  async fetchDoctors() {
    await useMedicos.loadMedicosByCurrentUser()
  }

  get bateMapaOptions() {
    if (this.area.toLowerCase() !== 'mapacirurgico') return []
    const result = []
    Object.entries((this.getStore as BackofficeMapaCirurgicoStore).templateMapaCirurgico).forEach(([key, value]) => {
      if (value) {
        // @ts-ignore
        result.push(this.bateMapaBaseOptions.find((item: BateMapaArea) => item.id === key))
      }
    })
    return result
  }

  clearStatusAreaBateMapa() {
    (this.getStore as BackofficeMapaCirurgicoStore).setStatusAreaBateMapa([])
  }

  get modalDe() {
    return this.modDe
  }

  set modalDe(value: boolean) {
    this.modDe = value
  }

  get modalAte() {
    return this.modAte
  }

  set modalAte(value: boolean) {
    this.modAte = value
  }

  @Watch('modalDe')
  onChangeModalDe(n, o) {
    //
  }

  @Watch('modalAte')
  onChangeModalAte(n, o) {
    //
  }

  get filterLoading() {
    return this.fltLoading
  }

  set filterLoading(value: boolean) {
    this.fltLoading = value
  }

  get getStore() {
    switch (this.area.toLowerCase()) {
      case 'autorizacao':
        return getModule(BackofficeAutorizacaoStore, this.$store)
      case 'preanestesico':
        return getModule(BackofficePreAnestesicoStore, this.$store)
      case 'orcamento':
        return getModule(BackofficeOrcamentoStore, this.$store)
      case 'agenciatransfusional':
        return getModule(BackofficeAgenciaTransfusionalStore, this.$store)
      case 'mapacirurgico':
        return getModule(BackofficeMapaCirurgicoStore, this.$store)
      case 'suprimentos':
        return getModule(BackofficeSuprimentosStore, this.$store)
      case 'fidelizacao':
        return getModule(BackofficeFidelizacaoStore, this.$store)
      case 'farmacia':
        return getModule(BackofficeFarmaciaStore, this.$store)
      default:
        return getModule(BackofficeAgendamentoStore, this.$store)
    }
  }

  get drawer() {
    return this.getStore.filterDrawer
  }

  set drawer(value: boolean) {
    this.getStore.setFilterDrawer(value)
  }

  get tipoPeriodo() {
    return this.getStore.tipoPeriodo
  }

  set tipoPeriodo(value: string) {
    this.getStore.setTipoPeriodo(value)
  }

  get paciente() {
    return this.getStore.paciente
  }

  set paciente(value) {
    this.getStore.setPaciente(value)
  }

  get medicoId() {
    return this.getStore.medicoId
  }

  set medicoId(value) {
    this.getStore.setMedicoId(value)
  }

  get numeroAgendamento() {
    return this.getStore.numeroAgendamento
  }

  set numeroAgendamento(value) {
    this.getStore.setNumeroAgendamento(value)
  }

  get ordenadoPor() {
    return this.getStore.ordenadoPorId
  }

  set ordenadoPor(value) {
    this.getStore.setOrdenadoPorId(value)
  }

  get getNovaDataSolicitada() {
    return this.getStore.novaDataSolicitadaFiltro
  }

  set getNovaDataSolicitada(value) {
    this.getStore.setNovaDataSolicitadaFiltro(value)
  }

  get getDataPrevista() {
    return this.getStore.dataPrevistaFiltro
  }

  set getDataPrevista(value) {
    this.getStore.setDataPrevistaFiltro(value)
  }

  get getHospitais() {
    return this.getStore.hospitaisFiltro
  }

  set getHospitais(value: any) {
    this.getStore.setHospitaisFiltro(value)
  }

  get getCentrosCirurgico() {
    return this.getStore.centrosCirurgico
  }

  get getCentroCirurgico() {
    return this.getStore.centroCirurgico
  }

  set getCentroCirurgico(value: any) {
    this.getStore.setCentroCirurgico(value)
  }

  get procedimentoPrincipalTipoTabela() {
    return (this.getStore as FiltroProcedimentoPrincipal).procedimentoPrincipalTipoTabela
  }

  set procedimentoPrincipalTipoTabela(value: TipoTabelaProcedimentoEnum[]) {
    (this.getStore as FiltroProcedimentoPrincipal).setProcedimentoPrincipalTipoTabela(value)
  }

  get procedimentoPrincipalIds() {
    return (this.getStore as FiltroProcedimentoPrincipal).procedimentoPrincipalIds
  }

  set procedimentoPrincipalIds(value: string[]) {
    (this.getStore as FiltroProcedimentoPrincipal).setProcedimentoPrincipalIds(value)
  }

  get primeiroHospitalFiltro() {
    return this.getHospitais.length > 0 ? this.getHospitais[0] : null
  }

  get getConvenio() {
    return this.getStore.convenioFiltro
  }

  set getConvenio(value: any) {
    this.getStore.setConvenioFiltro(value)
  }

  get getStatusPrecificacaoOperadora() {
    return this.getStore.statusPrecificacaoOperadoraFiltro
  }

  set getStatusPrecificacaoOperadora(value: string | null) {
    this.getStore.setStatusPrecificacaoOperadora(value)
  }

  get getPreAnestesia() {
    return this.getStore.preAnestesiaFiltro
  }

  set getPreAnestesia(value: string) {
    this.getStore.setPreAnestesiaFiltro(value)
  }

  get getOpmeFiltro() {
    return this.getStore.opmeFiltro
  }

  set getOpmeFiltro(value: any) {
    this.getStore.setOpmeFiltro(value)
  }

  get getAltaPrioridadeFiltro() {
    return (this.getStore as BackofficeAgendamentoStore | BackofficeAutorizacaoStore).altaPrioridadeFiltro
  }

  set getAltaPrioridadeFiltro(value: boolean | null) {
    (this.getStore as BackofficeAgendamentoStore | BackofficeAutorizacaoStore).setAltaPrioridadeFiltro(value)
  }

  get getAceiteMedicoFiltro() {
    return (this.getStore as BackofficeAgendamentoStore | BackofficeAutorizacaoStore | BackofficeMapaCirurgicoStore).autorizacaoParcialAceitaPeloMedicoFiltro
  }

  set getAceiteMedicoFiltro(value: boolean | null) {
    (this.getStore as BackofficeAgendamentoStore | BackofficeAutorizacaoStore | BackofficeMapaCirurgicoStore).setAutorizacaoParcialAceitaPeloMedicoFiltro(value)
  }

  get getPrimeiroTratamentoFiltro() {
    return this.getStore.primeiroTratamentoFiltro
  }

  set getPrimeiroTratamentoFiltro(value: boolean | null) {
    this.getStore.setPrimeiroTratamentoFiltro(value)
  }

  get primeiroTratamentoOptions(): FiltroTriStateOption[] {
    return [
      { value: true, description: 'Sim' },
      { value: false, description: 'Não' },
      { value: null, description: 'Todos' },
    ]
  }

  get getLembreteStatusFiltro() {
    return this.getStore.lembreteStatusFiltro
  }

  set getLembreteStatusFiltro(value: any) {
    this.getStore.setLembreteStatusFiltro(value)
  }

  get getSexo() {
    return this.getStore.sexo
  }

  set getSexo(value: string) {
    this.getStore.setSexo(value)
  }

  get medicoSolicitanteEspecialidade() {
    return (this.getStore as FiltroMedicoEspecialidade).medicoSolicitanteEspecialidade
  }

  set medicoSolicitanteEspecialidade(value: string[]) {
    (this.getStore as FiltroMedicoEspecialidade).setMedicoSolicitanteEspecialidade(value)
  }

  get tecnicaDaCirurgia() {
    return (this.getStore as BackofficeAgendamentoStore).tecnicaDaCirurgia
  }

  set tecnicaDaCirurgia(value: string) {
    (this.getStore as BackofficeAgendamentoStore).setTecnicaDaCirurgia(value)
  }

  get tecnicasDaCirurgia() {
    return [
      { text: 'Robótica', value: TecnicaDaCirurgiaEnum.Robotica },
      { text: 'Vídeo', value: TecnicaDaCirurgiaEnum.Video },
      { text: 'Convencional', value: TecnicaDaCirurgiaEnum.Convencional },
    ]
  }

  get getSituacoesPendenciaAberta() {
    return this.getStore.situacoesPendenciaAbertaFiltro
  }

  set getSituacoesPendenciaAberta(value: any) {
    this.getStore.setSituacoesPendenciaAbertaFiltro(value)
  }

  removeSituacoesPendenciaAberta(item: any) {
    this.getStore.removeSituacoesPendenciaAbertaFiltro(item)
  }

  removeConvenio(item: string) {
    this.getStore.removeConvenioFiltro(item)
  }

  removeReservaUti(item: string) {
    this.getStore.removeReservaUti(item)
  }

  removeStatusRoboAutorizacao(item: string) {
    this.getStore.removeStatusRoboAutorizacao(item)
  }

  removeMapaCirurgicoStatus(item: string) {
    this.getStore.removeMapaCirurgicoStatus(item)
  }

  removeComplexidadeStatus(item: ComplexidadeEnum) {
    (this.getStore as FiltroComplexidade).removeComplexidadeStatus(item)
  }

  removeTipoAcomodacao(item: string) {
    this.getStore.removeTipoAcomodacao(item)
  }

  async removeHospital(item: string) {
    this.getStore.removeHospitaisFiltro(item)
    await this.loadCentroCirurgico()
  }

  async loadCentroCirurgico() {
    await this.getStore.getCentroCirurgicoByHospitalId({ hospitalIds: this.getHospitais })
  }

  get getDataVirtual() {
    return this.getStore.dataVirtualFiltro
  }

  get getItemParticular() {
    return this.getStore.possuiItemParticular
  }

  set getItemParticular(value) {
    this.getStore.setPossuiItemParticular(value)
  }

  get opcoesEhCirurgiaConjunta() {
    return [{ value: null, text: 'Todas' }, { value: true, text: 'Sim' }, { value: false, text: 'Não' }]
  }

  get getEhCirurgiaConjunta() {
    if ('ehCirurgiaConjunta' in this.getStore) {
      return this.getStore.ehCirurgiaConjunta
    }
    return null
  }

  set getEhCirurgiaConjunta(value) {
    if ('setEhCirurgiaConjunta' in this.getStore) {
      this.getStore.setEhCirurgiaConjunta(value)
    }
  }

  get getPacienteEstaInternado() {
    if ('pacienteEstaInternado' in this.getStore) {
      return this.getStore.pacienteEstaInternado
    }
    return null
  }

  set getPacienteEstaInternado(value) {
    if ('setPacienteEstaInternado' in this.getStore) {
      this.getStore.setPacienteEstaInternado(value)
    }
  }

  get getAreaBateMapa() {
    const store = this.getStore as BackofficeMapaCirurgicoStore
    return store.areaBateMapa
  }

  set getAreaBateMapa(value) {
    const store = this.getStore as BackofficeMapaCirurgicoStore
    store.setAreaBateMapa(value)
  }

  get getStatusAreaBateMapa() {
    return (this.getStore as BackofficeMapaCirurgicoStore).statusAreaBateMapa
  }

  set getStatusAreaBateMapa(value) {
    (this.getStore as BackofficeMapaCirurgicoStore).setStatusAreaBateMapa(value)
  }

  set getDataVirtual(value) {
    this.getStore.setDataVirtualFiltro(value)
  }

  get getOrigem() {
    return this.getStore.origemFiltro
  }

  set getOrigem(value) {
    this.getStore.setOrigemFiltro(value)
  }

  get getCaraterDaCirurgia() {
    return this.getStore.caraterFiltro
  }

  set getCaraterDaCirurgia(value) {
    this.getStore.setCaraterFiltro(value)
  }

  get complexidade() {
    return (this.getStore as FiltroComplexidade).complexidade
  }

  set complexidade(value: ComplexidadeEnum[]) {
    (this.getStore as FiltroComplexidade).setComplexidade(value)
  }

  get de() {
    return this.getStore.deFiltro
  }

  set de(value: Date | string | null) {
    this.getStore.setDeFiltro(value)
  }

  get ate() {
    return this.getStore.ateFiltro
  }

  set ate(value: Date | string | null) {
    this.getStore.setAteFiltro(value)
  }

  get formattedDe() {
    return this.formatDate(this.de)
  }

  get formattedAte() {
    return this.formatDate(this.ate)
  }

  configFields: any = {
    fidelizacao: [
      'hospitais',
      'paciente',
      'caraterDaCirurgia',
      'medico',
      'itemParticular',
      'primeiroTratamento',
    ],
    agendamento: [
      'ordenadoPor',
      'paciente',
      'medico',
      'reserva',
      'operadora',
      'statusPreAnestesico',
      'opme',
      'novaDataSolicitada',
      'dataPrevista',
      'dataVirtual',
      'cirurgiaRealizada',
      'lembreteStatus',
      'cirurgiasPorPeriodo',
      'hospitais',
      'origem',
      'caraterDaCirurgia',
      'especialidade',
      'tecnicaDaCirurgia',
      'centroCirurgico',
      'situacoesPendenciaAberta',
      'itemParticular',
      'cirurgiaConjunta',
      'pacienteEstaInternado',
      'complexidade',
      'altaPrioridade',
      'procedimentoPrincipalTipoTabela',
      'procedimentoPrincipalIds',
      'aceiteMedico',
      'primeiroTratamento',
    ],
    autorizacao: [
      'ordenadoPor',
      'paciente',
      'medico',
      'reserva',
      'operadora',
      'statusPreAnestesico',
      'opme',
      'novaDataSolicitada',
      'dataPrevista',
      'dataVirtual',
      'cirurgiaRealizada',
      'lembreteStatus',
      'cirurgiasPorPeriodo',
      'hospitais',
      'origem',
      'caraterDaCirurgia',
      'statusRoboAutorizacao',
      'especialidade',
      'centroCirurgico',
      'situacoesPendenciaAberta',
      'itemParticular',
      'complexidade',
      'altaPrioridade',
      'procedimentoPrincipalTipoTabela',
      'procedimentoPrincipalIds',
      'aceiteMedico',
      'primeiroTratamento',
    ],
    preAnestesico: [
      'ordenadoPor',
      'paciente',
      'medico',
      'reserva',
      'operadora',
      'cirurgiasPorPeriodo',
      'caraterDaCirurgia',
      'reservaUti',
      'cirurgiaRealizada',
      'itemParticular',
      'complexidade',
      'origem',
      'tecnicaDaCirurgia',
      'pacienteEstaInternado',
      'especialidade',
      'procedimentoPrincipalTipoTabela',
      'primeiroTratamento',
    ],
    suprimentos: [
      'ordenadoPor',
      'paciente',
      'medico',
      'reserva',
      'operadora',
      'statusPreAnestesico',
      'opme',
      'novaDataSolicitada',
      'dataPrevista',
      'dataVirtual',
      'cirurgiaRealizada',
      'lembreteStatus',
      'cirurgiasPorPeriodo',
      'hospitais',
      'origem',
      'caraterDaCirurgia',
      'especialidade',
      'tecnicaDaCirurgia',
      'centroCirurgico',
      'situacoesPendenciaAberta',
      'itemParticular',
      'procedimentoPrincipalTipoTabela',
      'procedimentoPrincipalIds',
      'primeiroTratamento',
    ],
    orcamento: [
      'ordenadoPor',
      'paciente',
      'medico',
      'reserva',
      'hospitais',
      'cirurgiasPorPeriodo',
      'caraterDaCirurgia',
      'tecnicaDaCirurgia',
      'itemParticular',
      'procedimentoPrincipalTipoTabela',
      'procedimentoPrincipalIds',
      'primeiroTratamento',
    ],
    agenciaTransfusional: [
      'ordenadoPor',
      'paciente',
      'medico',
      'reserva',
      'cirurgiasPorPeriodo',
      'caraterDaCirurgia',
      'operadora',
      'itemParticular',
      'procedimentoPrincipalTipoTabela',
      'primeiroTratamento',
    ],
    mapaCirurgico: [
      'ordenadoPor',
      'paciente',
      'medico',
      'reserva',
      'operadora',
      'reservaUti',
      'hospitais',
      'opme',
      'sexo',
      'caraterDaCirurgia',
      'tipoAcomodacao',
      'statusCirurgia',
      'centroCirurgico',
      'especialidade',
      'itemParticular',
      'statusArea',
      'pacienteEstaInternado',
      'complexidade',
      'procedimentoPrincipalTipoTabela',
      'procedimentoPrincipalIds',
      'aceiteMedico',
      'primeiroTratamento',
    ],
    farmacia: [
      'ordenadoPor',
      'paciente',
      'medico',
      'reserva',
      'operadora',
      'statusPreAnestesico',
      'opme',
      'novaDataSolicitada',
      'dataVirtual',
      'cirurgiaRealizada',
      'lembreteStatus',
      'cirurgiasPorPeriodo',
      'hospitais',
      'origem',
      'caraterDaCirurgia',
      'especialidade',
      'centroCirurgico',
      'situacoesPendenciaAberta',
      'procedimentoPrincipalTipoTabela',
      'procedimentoPrincipalIds',
      'primeiroTratamento',
    ],
  }

  resetModalDe() {
    this.de = null
    this.modalDe = false
  }

  resetModalAte() {
    this.ate = null
    this.modalAte = false
  }

  formatDate(date: Date | string | null) {
    if (!date) return null
    const [year, month, day] = date.toString().split('-')
    return `${day}/${month}/${year}`
  }

  minDate(date: string) {
    if (!date) return null
    const min = moment(date).add(1, 'day').format('YYYY-MM-DD')
    return min
  }

  maxDate(date: string) {
    if (!date) return null
    const max = moment(date).add(1, 'year').format('YYYY-MM-DD')
    return max
  }

  clearDate(field: string) {
    if (field === 'de') {
      this.de = null
      this.ate = null
    } else {
      this.ate = null
    }
  }

  enableField(field: string) {
    return this.configFields[this.area].includes(field)
  }

  get getCirurgiaRealizada() {
    return this.getStore.cirurgiaRealizada
  }

  set getCirurgiaRealizada(value: StatusCirurgiaEnum | null) {
    this.getStore.setCirurgiaRealizada(value)
  }

  get getReservaUti() {
    return this.getStore.reservaUti
  }

  set getReservaUti(value: string[]) {
    this.getStore.setReservaUti(value)
  }

  get getStatusRoboAutorizacao() {
    return this.getStore.statusRoboAutorizacao
  }

  set getStatusRoboAutorizacao(value: string[]) {
    this.getStore.setStatusRoboAutorizacao(value)
  }

  get getmapaCirurgicoStatus() {
    return this.getStore.mapaCirurgicoStatus
  }

  set getmapaCirurgicoStatus(value: string[]) {
    this.getStore.setmapaCirurgicoStatus(value)
  }

  get getTiposAcomodacao() {
    return this.getStore.tiposAcomodacao
  }

  set getTiposAcomodacao(value: string[]) {
    this.getStore.setTiposAcomodacao(value)
  }

  hasAnyFilter(): boolean {
    return this.getStore.paciente !== ''
    || this.getStore.medicoId !== ''
    || this.getStore.numeroAgendamento !== ''
    || this.getStore.novaDataSolicitadaFiltro !== false
    || this.getStore.dataPrevistaFiltro !== false
    || (this.getStore.hospitaisFiltro && this.getStore.hospitaisFiltro.length < 1)
    || (this.getStore.convenioFiltro && this.getStore.convenioFiltro.length < 1)
    || this.getStore.preAnestesiaFiltro !== ''
    || this.getStore.dataVirtualFiltro !== false
    || this.getStore.opmeFiltro !== ''
    || (this.getStore as BackofficeAgendamentoStore | BackofficeAutorizacaoStore).altaPrioridadeFiltro !== null
    || (this.getStore as BackofficeAgendamentoStore | BackofficeAutorizacaoStore | BackofficeMapaCirurgicoStore).autorizacaoParcialAceitaPeloMedicoFiltro !== null
    || this.getStore.lembreteStatusFiltro !== ''
    || ((this.getStore as FiltroComplexidade).complexidade && (this.getStore as FiltroComplexidade).complexidade.length < 1)
    || this.getStore.cirurgiaRealizada !== null
    || this.getStore.deFiltro !== null
    || this.getStore.ateFiltro !== null
    || (this.getStore.reservaUti !== null && this.getStore.reservaUti.length < 1)
    || this.getStore.sexo !== null
    || (this.getStore.tiposAcomodacao !== null && this.getStore.tiposAcomodacao.length < 1)
    || ((this.getStore as FiltroProcedimentoPrincipal).procedimentoPrincipalTipoTabela && (this.getStore as FiltroProcedimentoPrincipal).procedimentoPrincipalTipoTabela.length > 0)
    || ((this.getStore as FiltroProcedimentoPrincipal).procedimentoPrincipalIds && (this.getStore as FiltroProcedimentoPrincipal).procedimentoPrincipalIds.length > 0)
  }

  async search() {
    if (!this.de && this.enableField('cirurgiasPorPeriodo')) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Preencha o campo de Data de início do período', icon: 'warning', color: '#C62828' })
      return
    }

    this.filterLoading = true

    if (this.getNovaDataSolicitada) {
      this.getStore.setData('NovaDataSolicitada')
    } else {
      this.getStore.removeData('NovaDataSolicitada')
    }

    if (this.getDataPrevista) {
      this.getStore.setData('DataPrevista')
    } else {
      this.getStore.removeData('DataPrevista')
    }

    if (this.getDataVirtual) {
      this.getStore.setDataAgendamentoVirtual(true)
    } else {
      this.getStore.setDataAgendamentoVirtual(false)
    }
    this.getStore.clearAgendamentosCirurgia()
    // @ts-ignore

    this.getStore.setPagina(1)
    await this.getStore.loadAgendamentosMedicoSearch()


    this.getStore.setFilterOn(this.hasAnyFilter())
    this.filterLoading = false
  }

  async clear() {
    this.getStore.clearFiltro()
    this.getStore.setOrderBy('DataUltimaInteracaoAsc')

    this.de = moment(new Date()).subtract(3, 'months').format('YYYY-MM-DD')

    this.getStore.setFilterOn(false)
  }

  windowHeight: number = 0

  getWindowHeight() {
    const doc: Document = document

    if (doc !== null) {
      this.windowHeight = doc.documentElement.clientHeight
    }
  }

  async mounted() {
    await this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowHeight)
    })
    this.getStore.init()
  }

  async updated() {
    await this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowHeight)
    })
  }
}
